/* eslint-disable indent */
import React, { useEffect, useState, useRef } from "react";
import WmsCollapse from "../../../components/WmsCollapse/WmsCollapse.jsx";
import WmsInput from "../../../components/WmsInput/WmsInput.jsx";
import WmsButton from "../../../components/WmsButton/WmsButton.jsx";
import WmsCheckBox from "../../../components/WmsCheckBox/WmsCheckBox.jsx";
import WmsDropdown from "../../../components/WmsDropdown/WmsDropdown.jsx";
import WmsRadio from "../../../components/WmsRadio/WmsRadio";
import WmsComboBox from "../../../components/WmsComboBox/WmsComboBox.jsx";
import WmsCustomTimePickerProto from "../../../components/WmsCustomTimePickerProto/WmsCustomTimePickerProto.jsx";
import * as gridConfig from "../small-parcel-carrier-account-grid-config.jsx";

import * as GlobalService from "./../../../global_services";
import WMSGridCheckBoxSelection from "../../../components/WMSGridCheckBoxSelection/WMSGridCheckBoxSelection";

declare var window: any;

interface Props {
    selector: string;
    connectionTermsOfService: any;
    connectionSchemaXgroupings: any;
    connectionSchemaProperties: any;
    connectionSchemaRequired: any;
    connectionDisplay: any;
    closeCarrierConnection: () => void;
    movePreviousStep: () => void;
    selectedCarrier: any;
    selectedProvider: any;
    currentCarrierImgUrl: any;
    totalSteps: number;
    currentLoginLabel: string;
    addDynamicCarrier: (obj: any, isFormResetLink: boolean) => void;
    addAccountListCarrier: (obj: any) => void;
    carrierConnectionBtnLoader: boolean;
    authUrl: string;
    isAuthUrl: boolean;
    authFlowCurrentStep: number;
    isCarrierConnectionWorking: string;
    startOverConnectionAuthorize: () => void;
    checkConnectionAuthorized: (obj: any, obj1: any) => void;
    checkCarrierConnectionBtnLoader: boolean;
    checkConnectionAuthorizedFinal: (obj: any) => void;
    setIsCarrierAccList: (obj: any) => void;
    carrierAccList: any;
    selectedCustomerName: string;
    selectedFacilityObj: any;
    selectedCustomerObj: any;
    isCarrierAccList: boolean;
}

const DynamicCarrierFormComponent: React.FC<Props> = (props: Props): any => {
    const [currentStep, setCurrentStep] = useState(2);
    const [currentCarrierObj, setCurrentCarrierObj] = useState({});
    const [isHaveAuthorization, setIsHaveAuthorization] = useState(null);
    const columns = gridConfig.getCarrierAccountListColumn();
    const schema = gridConfig.getCarrierAccountListSchema();
    const connectionSchemaXgroupings = props.connectionSchemaXgroupings;
    const authClipBoard = "#auth-clipboard";
    const xEnumDescrition = "x-enumDescriptions";
    const xInputType = "x-inputType";
    const selectOrEnterText = "Select or Enter ";
    const timePickerClassNameText = "dynamic-carriers-timepicker";

    const getFieldMaxLength = (inputName: string, inputElement: any) => {
        if (inputName === "apiToken") {
            return 0;
        }
        if (inputElement?.maxLength > 0) {
            return inputElement.maxLength;
        }
        return 255;
    };

    const [showExpireLinkTimer, setShowExpireLinkTimer] = useState(false);
    const [isAuthReset, setIsAuthReset] = useState(false);
    const [isFormResetLink, setIsFormResetLink] = useState(false);
    const [isResetLinkCalling, setIsResetLinkCalling] = useState(false);
    const [showExpiredLinkMsg, setShowExpiredLinkMsg] = useState(false);
    const [counterSeconds, setCounterSeconds] = useState(600);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [authResetSeconds, setAuthResetSeconds] = useState(300);
    const [accountListSelection, setAccountListSelection] = useState([]);
    const [totalAccountListSelection, setTotalAccountListSelection] = useState(0);

    let intervalRef: any = useRef();
    let authResetRef: any = useRef();

    useEffect(() => {
        if (props.authFlowCurrentStep === 2 && isHaveAuthorization === false) {
            createContainerElement();

            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(decreaseSeconds, 1000);
        }
        if (props.authFlowCurrentStep === 2 && isHaveAuthorization === false && isFormResetLink) {
            setIsAuthReset(true);
            setIsFormResetLink(false);
            setIsResetLinkCalling(false);
            clearInterval(authResetRef.current);
            authResetRef.current = setInterval(decreaseAuthResetSeconds, 1000);
        }
    }, [props.authFlowCurrentStep, isHaveAuthorization, isFormResetLink]);

    const decreaseSeconds = () => {
        setCounterSeconds((prev) => {
            if (prev <= 1) {
                clearInterval(intervalRef.current);
                setShowExpiredLinkMsg(true);
                return 0;
            }
            return prev - 1;
        });
    };

    const decreaseAuthResetSeconds = () => {
        setAuthResetSeconds((prev) => {
            if (prev <= 1) {
                clearInterval(authResetRef.current);
                setIsAuthReset(false);
                setShowExpiredLinkMsg(false);
                setIsResetLinkCalling(false);
                return 0;
            }
            return prev - 1;
        });
    };

    const handleCarrierObjChange = async (e: any) => {
        let { name, value } = e.target;
        let finalValue = value;
        if (e.target.type === "checkbox") {
            finalValue = e.target.checked;
        }
        await Object.entries(props.connectionSchemaProperties).map(async ([inputName, inputElement], index) => {
            if (inputElement["x-enumDependentField"] === name) {
                let state = GlobalService.GetRegions(value);
                if ($(`#${inputName}`) && $(`#${inputName}`).data("kendoComboBox")) {
                    $(`#${inputName}`).data("kendoComboBox").value("");
                }
                inputElement[`${xEnumDescrition}`] = state;
                return inputElement;
            } else {
                return inputElement;
            }
        });
        setCurrentCarrierObj((prevState) => ({
            ...prevState,
            [name]: finalValue,
        }));
    };

    const handleClickNext = () => {
        if (props.isCarrierAccList) {
            let resourceList = [];
            var grid = $("#" + props.selector + "CarrierAccountList").data("kendoGrid");
            var dataSource = grid.dataSource;
            var data = dataSource.data();
            for (let i = 0; i < data.length; i++) {
                const carrierObj = data[`${i}`];
                if (accountListSelection.indexOf(carrierObj.carrierId) !== -1) {
                    resourceList.push({
                        accountNumber: carrierObj.accountNumber,
                        carrier: carrierObj.carrier,
                        provider: carrierObj.provider,
                        carrierId: carrierObj.carrierId,
                        nickname: carrierObj.nickname,
                    });
                }
            }
            props.addAccountListCarrier(resourceList);
        } else if (props.totalSteps === currentStep) {
            if (
                (currentCarrierObj["countryCode"] && currentCarrierObj["countryCode"].length > 2) ||
                (currentCarrierObj["accountCountryCode"] && currentCarrierObj["accountCountryCode"].length > 2)
            ) {
                let name = currentCarrierObj["countryCode"] ? "countryCode" : "accountCountryCode";
                if ($(`#${name}`) && $(`#${name}`).data("kendoComboBox")) {
                    $(`#${name}`).data("kendoComboBox").value("");
                }
                setCurrentCarrierObj((prevState) => ({
                    ...prevState,
                    [name]: "",
                }));
                return;
            }
            // Add Carrier Section
            setIsAuthReset(isFormResetLink);
            setIsFormResetLink(false);
            setIsResetLinkCalling(false);
            props.addDynamicCarrier(currentCarrierObj, isFormResetLink);
        } else {
            // Next Step Section
            let nxtStep = currentStep + 1;
            setCurrentStep(nxtStep);
        }
    };

    const movePreviousStep = () => {
        if (currentStep === 2 && props.isCarrierAccList === false) {
            props.movePreviousStep();
        } else {
            if (props.isCarrierAccList) {
                props.setIsCarrierAccList(false);
                return;
            }
            let prvStep = currentStep - 1;
            setCurrentStep(prvStep);
        }
    };

    const isDisabledNextButton = () => {
        let isDisabled = false;
        if (props.isCarrierAccList) {
            isDisabled = totalAccountListSelection === 0;
        } else if (props.totalSteps === 3 && props.totalSteps !== currentStep) {
            if (!currentCarrierObj["agreeToCarrierTOS"]) {
                isDisabled = true;
            }
        } else {
            for (const key in props.connectionSchemaProperties) {
                if (
                    key !== "agreeToCarrierTOS" &&
                    props.connectionSchemaRequired?.indexOf(key) !== -1 &&
                    !currentCarrierObj[`${key}`]
                ) {
                    isDisabled = true;
                    break;
                }
            }
        }
        return isDisabled;
    };

    const getDropdownOptions = (dropdownData: any, baseCall) => {
        let dropdownOptions = [];
        for (const dKey in dropdownData) {
            let dataObj;
            if (typeof dropdownData[`${dKey}`] === "string") {
                dataObj = {
                    Name: dropdownData[`${dKey}`],
                    NameValue: baseCall === "ancillaryEndorsement" ? dKey : dKey.toUpperCase(),
                };
            } else {
                dataObj = {
                    Name: dropdownData[`${dKey}`].Name,
                    NameValue: dropdownData[`${dKey}`].RegionCode,
                };
            }
            dropdownOptions.push(dataObj);
        }
        return dropdownOptions;
    };

    const onClickAuthorization = (e: any) => {
        if (e.target.name === "haveAuthoration") {
            setIsHaveAuthorization(true);
        } else {
            setIsHaveAuthorization(false);
        }
    };

    const startOverConnectionAuthorize = () => {
        props.startOverConnectionAuthorize();
        setIsHaveAuthorization(null);
    };

    const checkConnectionAuthorized = () => {
        props.checkConnectionAuthorized(currentCarrierObj, isHaveAuthorization);
        if (isHaveAuthorization === false) {
            setLinkExpireTimer();
        }
    };

    const checkConnectionAuthorizedFinal = () => {
        props.checkConnectionAuthorizedFinal(currentCarrierObj);
    };

    const tryAgainConnectionAuthorized = () => {
        if (isHaveAuthorization === true && props.authUrl) {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open(props.authUrl, "_blank", "width=800,height=750,top=200,left=560,resizable=yes");
        }
    };

    const createContainerElement = () => {
        if (document.getElementById("auth-clipboard") == null) {
            let container = document.createElement("div");
            container.id = "auth-clipboard-container";
            container.setAttribute("style", ["opacity: 0;height: 0;width: 0;"].join(""));
            document.body.appendChild(container);
            let textarea = document.createElement("textarea");
            textarea.id = "auth-clipboard";
            // eslint-disable-next-line no-self-assign
            textarea = textarea;
            container.appendChild(textarea);
        }
    };

    const copyLinkToClipBoard = () => {
        var copyText = props.authUrl;
        var copyTextarea: HTMLInputElement = document.querySelector(authClipBoard);
        copyTextarea.appendChild(document.createTextNode(copyText));
        copyTextarea.select();
        document.execCommand("copy");
        $(authClipBoard).text("");
        GlobalService.notification("success", window.translate("Label_Link_Copied"));
    };

    const copyInstructionToClipBoard = () => {
        var copyText =
            "To connect your " + props.selectedCarrier + " account to your 3PL’s warehouse management system: \n";
        copyText += "Go to: \n" + props.authUrl + "\n";
        copyText += "Log in with your " + props.selectedCarrier + " account";
        copyText += "This link is valid for 10 minutes. \n";
        var copyTextarea: HTMLInputElement = document.querySelector(authClipBoard);
        copyTextarea.appendChild(document.createTextNode(copyText));
        copyTextarea.select();
        document.execCommand("copy");
        $(authClipBoard).text("");
        GlobalService.notification("success", window.translate("Label_Instruction_Copied"));
    };

    const setLinkExpireTimer = () => {
        setShowExpireLinkTimer(true);
        setIsFormResetLink(false);
        setShowExpiredLinkMsg(false);
    };

    const resetLink = () => {
        setIsFormResetLink(true);
        setIsAuthReset(false);
        setIsResetLinkCalling(true);
        setShowExpiredLinkMsg(false);
        // Add Carrier Section
        props.addDynamicCarrier(currentCarrierObj, true);
    };

    const selectAccountListRow = (arrOfIds) => {
        let arrOfSelection = [];
        Object.keys(arrOfIds).map((key) => {
            if (arrOfIds[`${key}`]) {
                arrOfSelection.push(key);
            }
            return true;
        });
        setAccountListSelection(arrOfSelection);
        setTotalAccountListSelection(arrOfSelection.length);
    };

    return (
        <div>
            <div
                className={
                    "model-content-wrapper dynamic-carrier-wrapper" +
                    (props.isCarrierAccList ? " carrier-account-list" : "")
                }
            >
                <div className="connection-step-block">
                    <div className={"image-section " + (props.selectedCarrier === "Amazon Buy" ? "img-amazon" : "")}>
                        <img src={props.currentCarrierImgUrl} alt={props.currentCarrierImgUrl} />
                    </div>
                </div>
                {/* No Auth Flow */}
                {props.authFlowCurrentStep === 0 && !props.isCarrierAccList && (
                    <>
                        {/* STEP TWO SECTION */}
                        {props.totalSteps === 3 && currentStep !== props.totalSteps ? (
                            <WmsCollapse
                                id={"carrierAgreementSection"}
                                headerLabel={window.translate("Label_Agreement")}
                                showCollapseText={false}
                                showCollapseIcon={false}
                            >
                                <div dangerouslySetInnerHTML={{ __html: props.connectionTermsOfService }}></div>
                                {/* Add Agree To TOS */}
                                {Object.entries(props.connectionSchemaProperties).map(
                                    ([inputName, inputElement], index) =>
                                        inputElement["type"] === "boolean" &&
                                        inputName === "agreeToCarrierTOS" && (
                                            <WmsCheckBox
                                                id={inputName}
                                                key={index}
                                                name={inputName}
                                                wmsSelector={props.selector + inputName}
                                                onChangeFunc={handleCarrierObjChange}
                                                label={
                                                    inputElement["name"]
                                                        ? inputElement["name"]
                                                        : inputName.charAt(0).toUpperCase() + inputName.slice(1)
                                                }
                                                checked={currentCarrierObj[`${inputName}`] === true}
                                                isRounded={true}
                                            />
                                        )
                                )}
                            </WmsCollapse>
                        ) : (
                            // STEP THREE SECTION
                            <>
                                {/* X-Grouping Section */}
                                {connectionSchemaXgroupings.length === undefined ||
                                connectionSchemaXgroupings.length > 0 ? (
                                    props.selectedCarrier !== "Lasership" &&
                                    props.selectedCarrier !== "FedEx SmartPost" ? (
                                        Object.keys(connectionSchemaXgroupings)
                                            .reverse()
                                            .map((xKey) => (
                                                <WmsCollapse
                                                    key={xKey}
                                                    id={"DynamicCarrierFormScreen" + xKey}
                                                    headerLabel={connectionSchemaXgroupings[`${xKey}`].groupTitle}
                                                    showCollapseText={false}
                                                    showCollapseIcon={false}
                                                >
                                                    <div className="account-info-section">
                                                        {Object.entries(props.connectionSchemaProperties).map(
                                                            ([inputName, inputElement], index) =>
                                                                inputElement["type"] === "string" &&
                                                                connectionSchemaXgroupings[`${xKey}`].fields?.indexOf(
                                                                    inputName
                                                                ) !== -1 ? (
                                                                    inputElement["enum"] ? (
                                                                        <WmsDropdown
                                                                            id={inputName}
                                                                            key={index}
                                                                            name={inputName}
                                                                            wmsSelector={props.selector + inputName}
                                                                            label={
                                                                                inputElement["name"]
                                                                                    ? inputElement["name"]
                                                                                    : inputName
                                                                                          .charAt(0)
                                                                                          .toUpperCase() +
                                                                                      inputName.slice(1)
                                                                            }
                                                                            onChangeFunc={handleCarrierObjChange}
                                                                            value={currentCarrierObj[`${inputName}`]}
                                                                            options={getDropdownOptions(
                                                                                inputElement[`${xEnumDescrition}`],
                                                                                inputName
                                                                            )}
                                                                            valueField="NameValue"
                                                                            textField="Name"
                                                                            parentClassName="form_group"
                                                                            extraWrapperClass="width-100"
                                                                            blankFirstOption={true}
                                                                            required={
                                                                                props.connectionSchemaRequired?.indexOf(
                                                                                    inputName
                                                                                ) !== -1
                                                                            }
                                                                        />
                                                                    ) : inputElement[`${xEnumDescrition}`] ? (
                                                                        <WmsComboBox
                                                                            id={inputName}
                                                                            key={index}
                                                                            name={inputName}
                                                                            label={
                                                                                inputElement["name"]
                                                                                    ? inputElement["name"]
                                                                                    : inputName
                                                                                          .charAt(0)
                                                                                          .toUpperCase() +
                                                                                      inputName.slice(1)
                                                                            }
                                                                            wmsSelector={props.selector + inputName}
                                                                            value={currentCarrierObj[`${inputName}`]}
                                                                            onChangeFunc={handleCarrierObjChange}
                                                                            options={getDropdownOptions(
                                                                                inputElement[`${xEnumDescrition}`],
                                                                                inputName
                                                                            )}
                                                                            placeholder={
                                                                                selectOrEnterText +
                                                                                (inputElement["name"]
                                                                                    ? inputElement["name"]
                                                                                    : inputName
                                                                                          .charAt(0)
                                                                                          .toUpperCase() +
                                                                                      inputName.slice(1))
                                                                            }
                                                                            valueField="NameValue"
                                                                            textField="Name"
                                                                            parentClassName="form_group width-100"
                                                                            required={
                                                                                props.connectionSchemaRequired?.indexOf(
                                                                                    inputName
                                                                                ) !== -1
                                                                            }
                                                                        />
                                                                    ) : inputElement[`${xInputType}`] &&
                                                                      inputElement[`${xInputType}`] === "time" ? (
                                                                        <WmsCustomTimePickerProto
                                                                            id={inputName}
                                                                            key={index}
                                                                            name={inputName}
                                                                            wmsSelector={props.selector + inputName}
                                                                            label={inputElement["name"]}
                                                                            value={currentCarrierObj[`${inputName}`]}
                                                                            defaultTime=""
                                                                            onChangeFunc={handleCarrierObjChange}
                                                                            defaultFormat={"HH:mm"}
                                                                            isDateParseInCustomFormat={"HH:mm"}
                                                                            interval={15}
                                                                            required={
                                                                                props.connectionSchemaRequired?.indexOf(
                                                                                    inputName
                                                                                ) !== -1
                                                                            }
                                                                            extraWrapperClass={timePickerClassNameText}
                                                                        />
                                                                    ) : (
                                                                        <WmsInput
                                                                            id={inputName}
                                                                            key={index}
                                                                            inputName={inputName}
                                                                            wmsSelector={props.selector + inputName}
                                                                            onChangeFunc={handleCarrierObjChange}
                                                                            label={inputElement["name"]}
                                                                            value={currentCarrierObj[`${inputName}`]}
                                                                            maxLength={getFieldMaxLength(
                                                                                inputName,
                                                                                inputElement
                                                                            )}
                                                                            required={
                                                                                props.connectionSchemaRequired?.indexOf(
                                                                                    inputName
                                                                                ) !== -1
                                                                            }
                                                                            extraWrapperClass={"width-100"}
                                                                        />
                                                                    )
                                                                ) : (
                                                                    inputElement["type"] === "boolean" &&
                                                                    inputName !== "agreeToCarrierTOS" &&
                                                                    connectionSchemaXgroupings[
                                                                        `${xKey}`
                                                                    ].fields?.indexOf(inputName) !== -1 && (
                                                                        <WmsCheckBox
                                                                            id={inputName}
                                                                            key={index}
                                                                            name={inputName}
                                                                            wmsSelector={props.selector + inputName}
                                                                            onChangeFunc={handleCarrierObjChange}
                                                                            label={inputElement["name"]}
                                                                            checked={
                                                                                currentCarrierObj[`${inputName}`] ===
                                                                                true
                                                                            }
                                                                            isRounded={true}
                                                                            parentClassName={"width-100"}
                                                                        />
                                                                    )
                                                                )
                                                        )}
                                                    </div>
                                                </WmsCollapse>
                                            ))
                                    ) : (
                                        Object.keys(connectionSchemaXgroupings).map((xKey) => (
                                            <WmsCollapse
                                                key={xKey}
                                                id={"DynamicCarrierFormScreen" + xKey}
                                                headerLabel={connectionSchemaXgroupings[`${xKey}`].groupTitle}
                                                showCollapseText={false}
                                                showCollapseIcon={false}
                                            >
                                                <div className="account-info-section">
                                                    {Object.entries(props.connectionSchemaProperties).map(
                                                        // eslint-disable-next-line sonarjs/no-identical-functions
                                                        ([inputName, inputElement], index) =>
                                                            inputElement["type"] === "string" &&
                                                            connectionSchemaXgroupings[`${xKey}`].fields?.indexOf(
                                                                inputName
                                                            ) !== -1 ? (
                                                                inputElement["enum"] ? (
                                                                    <WmsDropdown
                                                                        id={inputName}
                                                                        key={index}
                                                                        name={inputName}
                                                                        wmsSelector={props.selector + inputName}
                                                                        label={
                                                                            inputElement["name"]
                                                                                ? inputElement["name"]
                                                                                : inputName.charAt(0).toUpperCase() +
                                                                                  inputName.slice(1)
                                                                        }
                                                                        onChangeFunc={handleCarrierObjChange}
                                                                        value={currentCarrierObj[`${inputName}`]}
                                                                        options={getDropdownOptions(
                                                                            inputElement[`${xEnumDescrition}`],
                                                                            inputName
                                                                        )}
                                                                        valueField="NameValue"
                                                                        textField="Name"
                                                                        parentClassName="form_group"
                                                                        extraWrapperClass="width-100"
                                                                        blankFirstOption={true}
                                                                        required={
                                                                            props.connectionSchemaRequired?.indexOf(
                                                                                inputName
                                                                            ) !== -1
                                                                        }
                                                                    />
                                                                ) : inputElement[`${xEnumDescrition}`] ? (
                                                                    <WmsComboBox
                                                                        id={inputName}
                                                                        key={index}
                                                                        name={inputName}
                                                                        label={
                                                                            inputElement["name"]
                                                                                ? inputElement["name"]
                                                                                : inputName.charAt(0).toUpperCase() +
                                                                                  inputName.slice(1)
                                                                        }
                                                                        wmsSelector={props.selector + inputName}
                                                                        value={currentCarrierObj[`${inputName}`]}
                                                                        onChangeFunc={handleCarrierObjChange}
                                                                        options={getDropdownOptions(
                                                                            inputElement[`${xEnumDescrition}`],
                                                                            inputName
                                                                        )}
                                                                        placeholder={
                                                                            selectOrEnterText +
                                                                            (inputElement["name"]
                                                                                ? inputElement["name"]
                                                                                : inputName.charAt(0).toUpperCase() +
                                                                                  inputName.slice(1))
                                                                        }
                                                                        valueField="NameValue"
                                                                        textField="Name"
                                                                        parentClassName="form_group width-100"
                                                                        required={
                                                                            props.connectionSchemaRequired?.indexOf(
                                                                                inputName
                                                                            ) !== -1
                                                                        }
                                                                    />
                                                                ) : inputElement[`${xInputType}`] &&
                                                                  inputElement[`${xInputType}`] === "time" ? (
                                                                    <WmsCustomTimePickerProto
                                                                        id={inputName}
                                                                        key={index}
                                                                        name={inputName}
                                                                        wmsSelector={props.selector + inputName}
                                                                        label={inputElement["name"]}
                                                                        value={currentCarrierObj[`${inputName}`]}
                                                                        defaultTime=""
                                                                        onChangeFunc={handleCarrierObjChange}
                                                                        defaultFormat={"HH:mm"}
                                                                        isDateParseInCustomFormat={"HH:mm"}
                                                                        interval={15}
                                                                        required={
                                                                            props.connectionSchemaRequired?.indexOf(
                                                                                inputName
                                                                            ) !== -1
                                                                        }
                                                                        extraWrapperClass={timePickerClassNameText}
                                                                    />
                                                                ) : (
                                                                    <WmsInput
                                                                        id={inputName}
                                                                        key={index}
                                                                        inputName={inputName}
                                                                        wmsSelector={props.selector + inputName}
                                                                        onChangeFunc={handleCarrierObjChange}
                                                                        label={inputElement["name"]}
                                                                        value={currentCarrierObj[`${inputName}`]}
                                                                        maxLength={getFieldMaxLength(
                                                                            inputName,
                                                                            inputElement
                                                                        )}
                                                                        required={
                                                                            props.connectionSchemaRequired?.indexOf(
                                                                                inputName
                                                                            ) !== -1
                                                                        }
                                                                        extraWrapperClass={"width-100"}
                                                                    />
                                                                )
                                                            ) : (
                                                                inputElement["type"] === "boolean" &&
                                                                inputName !== "agreeToCarrierTOS" &&
                                                                connectionSchemaXgroupings[`${xKey}`].fields?.indexOf(
                                                                    inputName
                                                                ) !== -1 && (
                                                                    <WmsCheckBox
                                                                        id={inputName}
                                                                        key={index}
                                                                        name={inputName}
                                                                        wmsSelector={props.selector + inputName}
                                                                        onChangeFunc={handleCarrierObjChange}
                                                                        label={inputElement["name"]}
                                                                        checked={
                                                                            currentCarrierObj[`${inputName}`] === true
                                                                        }
                                                                        isRounded={true}
                                                                        parentClassName={"width-100"}
                                                                    />
                                                                )
                                                            )
                                                    )}
                                                </div>
                                            </WmsCollapse>
                                        ))
                                    )
                                ) : (
                                    // No X-Grouping Section
                                    <WmsCollapse
                                        id={"DynamicCarrierFormScreen"}
                                        headerLabel={window.translate("Label_Account_Information")}
                                        showCollapseText={false}
                                        showCollapseIcon={false}
                                    >
                                        <div
                                            className={`${props.connectionDisplay ? "connection-display-wrapper" : ""}`}
                                        >
                                            <div className="account-info-section">
                                                {Object.entries(props.connectionSchemaProperties).map(
                                                    ([inputName, inputElement], index) =>
                                                        inputElement["type"] === "string" ? (
                                                            inputElement["enum"] ? (
                                                                <WmsDropdown
                                                                    id={inputName}
                                                                    key={index}
                                                                    name={inputName}
                                                                    wmsSelector={props.selector + inputName}
                                                                    label={
                                                                        inputElement["name"]
                                                                            ? inputElement["name"]
                                                                            : inputName.charAt(0).toUpperCase() +
                                                                              inputName.slice(1)
                                                                    }
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    value={currentCarrierObj[`${inputName}`]}
                                                                    options={getDropdownOptions(
                                                                        inputElement[`${xEnumDescrition}`],
                                                                        inputName
                                                                    )}
                                                                    valueField="NameValue"
                                                                    textField="Name"
                                                                    parentClassName="form_group"
                                                                    extraWrapperClass="width-100"
                                                                    blankFirstOption={true}
                                                                    required={
                                                                        props.connectionSchemaRequired?.indexOf(
                                                                            inputName
                                                                        ) !== -1
                                                                    }
                                                                />
                                                            ) : inputElement[`${xEnumDescrition}`] ? (
                                                                <WmsComboBox
                                                                    id={inputName}
                                                                    key={index}
                                                                    name={inputName}
                                                                    label={
                                                                        inputElement["name"]
                                                                            ? inputElement["name"]
                                                                            : inputName.charAt(0).toUpperCase() +
                                                                              inputName.slice(1)
                                                                    }
                                                                    wmsSelector={props.selector + inputName}
                                                                    value={currentCarrierObj[`${inputName}`]}
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    options={getDropdownOptions(
                                                                        inputElement[`${xEnumDescrition}`],
                                                                        inputName
                                                                    )}
                                                                    placeholder={
                                                                        selectOrEnterText +
                                                                        (inputElement["name"]
                                                                            ? inputElement["name"]
                                                                            : inputName.charAt(0).toUpperCase() +
                                                                              inputName.slice(1))
                                                                    }
                                                                    valueField="NameValue"
                                                                    textField="Name"
                                                                    required={
                                                                        props.connectionSchemaRequired?.indexOf(
                                                                            inputName
                                                                        ) !== -1
                                                                    }
                                                                    parentClassName="form_group width-100"
                                                                />
                                                            ) : inputElement[`${xInputType}`] &&
                                                              inputElement[`${xInputType}`] === "time" ? (
                                                                <WmsCustomTimePickerProto
                                                                    id={inputName}
                                                                    key={index}
                                                                    name={inputName}
                                                                    wmsSelector={props.selector + inputName}
                                                                    label={inputElement["name"]}
                                                                    value={currentCarrierObj[`${inputName}`]}
                                                                    defaultTime=""
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    defaultFormat={"HH:mm"}
                                                                    isDateParseInCustomFormat={"HH:mm"}
                                                                    interval={15}
                                                                    required={
                                                                        props.connectionSchemaRequired?.indexOf(
                                                                            inputName
                                                                        ) !== -1
                                                                    }
                                                                    extraWrapperClass={timePickerClassNameText}
                                                                />
                                                            ) : (
                                                                <WmsInput
                                                                    id={inputName}
                                                                    key={index}
                                                                    inputName={inputName}
                                                                    wmsSelector={props.selector + inputName}
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    label={inputElement["name"]}
                                                                    value={currentCarrierObj[`${inputName}`]}
                                                                    maxLength={getFieldMaxLength(
                                                                        inputName,
                                                                        inputElement
                                                                    )}
                                                                    required={
                                                                        props.connectionSchemaRequired?.indexOf(
                                                                            inputName
                                                                        ) !== -1
                                                                    }
                                                                    extraWrapperClass={"width-100"}
                                                                />
                                                            )
                                                        ) : (
                                                            inputElement["type"] === "boolean" &&
                                                            inputName !== "agreeToCarrierTOS" && (
                                                                <WmsCheckBox
                                                                    id={inputName}
                                                                    key={index}
                                                                    name={inputName}
                                                                    wmsSelector={props.selector + inputName}
                                                                    onChangeFunc={handleCarrierObjChange}
                                                                    label={inputElement["name"]}
                                                                    checked={currentCarrierObj[`${inputName}`] === true}
                                                                    isRounded={true}
                                                                    parentClassName={"width-100"}
                                                                />
                                                            )
                                                        )
                                                )}
                                            </div>
                                            <>
                                                {props.connectionDisplay && (
                                                    <div className="connection-display-block">
                                                        <div className="pitney-bowes-seperator-wrapper">
                                                            <div className="pitney-bowes-seperator-word">OR</div>
                                                        </div>
                                                        <div className="pitney-bowes-create-account-btn">
                                                            <WmsButton
                                                                label={props.connectionDisplay.buttonText}
                                                                wmsSelector={props.selector + "CreateProviderAccount"}
                                                                buttonType="green"
                                                                onClickFunc={() => {
                                                                    // eslint-disable-next-line security/detect-non-literal-fs-filename
                                                                    window.open(
                                                                        props.connectionDisplay.buttonUrl,
                                                                        "_blank"
                                                                    );
                                                                }}
                                                                icon="fa-plus"
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        </div>
                                    </WmsCollapse>
                                )}
                            </>
                        )}
                    </>
                )}
                {/* Auth Flow Step One */}
                {props.authFlowCurrentStep === 1 && !props.isCarrierAccList && (
                    <div className="connection-step-block ups-auth-flow-wrapper">
                        <h3>Authorize with {props.selectedCarrier}</h3>
                        <p>Do you have the {props.selectedCarrier} credentials for this account?</p>
                        <div className="radio-wrapper">
                            <WmsRadio
                                id="haveAuthoration"
                                name="haveAuthoration"
                                label={window.translate("Label_Yes")}
                                wmsSelector={props.selector + "haveAuthoration"}
                                onChangeFunc={onClickAuthorization}
                                checked={isHaveAuthorization === true}
                            />
                            {isHaveAuthorization === true && (
                                <div className="alert-wrapper">
                                    <div className="title">
                                        <i className="fa fa-info-circle main-icon" aria-hidden="true"></i>
                                        <label>Have the {props.selectedCarrier} login and password ready</label>
                                    </div>
                                    <div className="description">
                                        <p>You will need to enter them in a new browser pop-up</p>
                                    </div>
                                </div>
                            )}
                            <WmsRadio
                                id="notHaveAuthoration"
                                name="notHaveAuthoration"
                                label={window.translate("Ask_For_Authoriz")}
                                wmsSelector={props.selector + "notHaveAuthoration"}
                                onChangeFunc={onClickAuthorization}
                                checked={isHaveAuthorization === false}
                            />
                            {isHaveAuthorization === false && (
                                <div className="alert-wrapper">
                                    <div className="title">
                                        <i className="fa fa-info-circle main-icon" aria-hidden="true"></i>
                                        <label>Please make sure they are ready to log in.</label>
                                    </div>
                                    <div className="description">
                                        <p>
                                            When you click “Next”, we’ll create a login link that you can share with the
                                            UPS account owner. The link will be valid for 10 minutes. You can reset it
                                            if it expires.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Auth Flow Step Two and Not Have Authorization */}
                {props.authFlowCurrentStep === 2 && isHaveAuthorization === false && !props.isCarrierAccList && (
                    <div className="connection-step-block ups-auth-flow-wrapper">
                        <h3>Authorize with {props.selectedCarrier}</h3>
                        {showExpireLinkTimer && (
                            <div className={isAuthReset ? "link-reset-alert" : "link-expire-alert"}>
                                <div>
                                    {isResetLinkCalling && (
                                        <div className="alert-text-wrapper reseting-msg">
                                            <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                            <p>Reseting the link...</p>
                                        </div>
                                    )}
                                    {isAuthReset && (
                                        <div className="alert-text-wrapper">
                                            <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                                            <div className="linked-reset">
                                                <h4>The link has been reset.</h4>
                                                <p>Please share the updated link with your customer.</p>
                                            </div>
                                        </div>
                                    )}
                                    {showExpiredLinkMsg === true && (
                                        <div className="alert-text-wrapper">
                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                            <div>
                                                <h4>The link has expired.</h4>
                                                <p>If you’d like to try again, please reset it.</p>
                                            </div>
                                        </div>
                                    )}
                                    {showExpiredLinkMsg === false &&
                                        isResetLinkCalling === false &&
                                        isAuthReset === false && (
                                            <div className="alert-text-wrapper expiring-msg">
                                                <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                <span>
                                                    The link will expire in{" "}
                                                    {window.moment.utc(counterSeconds * 1000).format("mm:ss")}{" "}
                                                </span>
                                            </div>
                                        )}
                                </div>
                                {!isAuthReset && (
                                    <div className="alert-btn-wrapper">
                                        <WmsButton
                                            label={window.translate("Label_Reset_Link")}
                                            buttonType="orange"
                                            wmsSelector={props.selector + "RestLink"}
                                            onClickFunc={resetLink}
                                            icon="fa-repeat"
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                        {((showExpiredLinkMsg === false && isResetLinkCalling === false) || isAuthReset) && (
                            <div>
                                <p>Share these instructions with the {props.selectedCarrier} account owner:</p>
                                <div className="connection-ups-wrapper">
                                    <p>
                                        To connect your {props.selectedCarrier} account to your 3PL’s warehouse
                                        management system:
                                    </p>

                                    <li>
                                        <i className="fa fa-circle" aria-hidden="true"></i>
                                        <div className="auth-url-wrapper">
                                            Go to{" "}
                                            <a href={props.authUrl} target="_blank" rel="noreferrer">
                                                {props.authUrl}
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <i className="fa fa-circle" aria-hidden="true"></i>
                                        <div>Log in with your {props.selectedCarrier} account</div>
                                    </li>

                                    <p>This link is valid for 10 minutes.</p>
                                </div>
                                <div className="copy-btn-wrapper">
                                    <WmsButton
                                        label={window.translate("Label_Copy_Instructions")}
                                        wmsSelector={props.selector + "CopyInstruction"}
                                        onClickFunc={copyInstructionToClipBoard}
                                        icon="fa fa-copy"
                                    />
                                    <WmsButton
                                        label={window.translate("Label_Copy_Link_Only")}
                                        wmsSelector={props.selector + "CopyLinkOnly"}
                                        onClickFunc={copyLinkToClipBoard}
                                        parentClassName="copy-link-btn"
                                        icon="fa fa-link"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Auth Flow Step Two and Three Combined */}
                {((props.authFlowCurrentStep === 2 && isHaveAuthorization === true) ||
                    (props.authFlowCurrentStep === 3 && isHaveAuthorization === false)) &&
                    !props.isCarrierAccList && (
                        <div className="connection-step-block ups-auth-flow-wrapper">
                            <h3>Authorize with {props.selectedCarrier}</h3>
                            {props.isCarrierConnectionWorking === "Yes" ? (
                                <div className="check-connection-success-alert">
                                    <i className="fa-regular fa-circle-check"></i> Your {props.selectedCarrier}{" "}
                                    connection is working!
                                </div>
                            ) : props.isCarrierConnectionWorking === "No" ? (
                                <>
                                    <div className="check-connection-error-alert">
                                        <h3>
                                            <i className="fa-regular fa-hexagon-exclamation"></i> Unable to establish
                                            your {props.selectedCarrier} connection
                                        </h3>
                                        <p>
                                            Wait a few seconds and check again. if after a few attempts the connection
                                            is still not established, you may need to start over.
                                        </p>
                                    </div>
                                    <div className="check-connection-wrapper">
                                        <WmsButton
                                            label={"Check " + props.selectedCarrier + " Connection"}
                                            wmsSelector={props.selector + "CheckConnectionFinal"}
                                            onClickFunc={checkConnectionAuthorizedFinal}
                                            disabled={props.checkCarrierConnectionBtnLoader}
                                            icon="fa fa-check"
                                        />
                                    </div>
                                </>
                            ) : (
                                <div>
                                    {isHaveAuthorization === true && (
                                        <>
                                            {props.checkCarrierConnectionBtnLoader === true ? (
                                                <div className="check-connection-loading-alert">
                                                    <i className="fa-solid fa-spinner-third fa-spin"></i> Checking
                                                    connection....
                                                </div>
                                            ) : (
                                                <p className="popup-title">
                                                    If you have successfully logged into {props.selectedCarrier}, check
                                                    your connection to make sure it`s established:
                                                </p>
                                            )}
                                            <div className="check-connection-wrapper">
                                                <WmsButton
                                                    label={"Check " + props.selectedCarrier + " Connection"}
                                                    wmsSelector={props.selector + "CheckConnectionFinal"}
                                                    onClickFunc={checkConnectionAuthorizedFinal}
                                                    disabled={props.checkCarrierConnectionBtnLoader}
                                                    icon="fa fa-check"
                                                />
                                            </div>
                                            {!props.checkCarrierConnectionBtnLoader && (
                                                <>
                                                    <hr></hr>
                                                    <div className="check-connection-wrapper">
                                                        <div className="popup-title">
                                                            Could not login or did not see the popup?
                                                        </div>
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                        <a onClick={tryAgainConnectionAuthorized}>Try again</a>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {isHaveAuthorization === false && (
                                        <>
                                            {props.checkCarrierConnectionBtnLoader === true ? (
                                                <div className="check-connection-loading-alert">
                                                    <i className="fa-solid fa-spinner-third fa-spin"></i> Checking
                                                    connection....
                                                </div>
                                            ) : (
                                                <>
                                                    <li>
                                                        Wait for the account owner to enter their{" "}
                                                        {props.selectedCarrier} credentials.
                                                    </li>
                                                    <li>
                                                        Check the {props.selectedCarrier} connection to make sure
                                                        everything is working.
                                                    </li>
                                                </>
                                            )}
                                            <div className="check-connection-wrapper">
                                                <WmsButton
                                                    label={"Check " + props.selectedCarrier + " Connection"}
                                                    wmsSelector={props.selector + "CheckConnectionFinal"}
                                                    onClickFunc={checkConnectionAuthorizedFinal}
                                                    disabled={props.checkCarrierConnectionBtnLoader}
                                                    icon="fa fa-check"
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                {props.isCarrierAccList && (
                    <div className="account-list-wrapper">
                        <div className="carrier-info-wrapper">
                            <div className="warehouse-info">
                                <label>{props.selectedFacilityObj ? "Warehouse:" : "Customer:"} </label>
                                <span>
                                    {props.selectedFacilityObj
                                        ? props.selectedFacilityObj.name
                                        : props.selectedCustomerObj.name}
                                </span>
                            </div>
                            <div className="carrier-info">
                                {props.selectedCarrier ? (
                                    <>
                                        <label>Carrier: </label>
                                        <span>{props.selectedCarrier}</span>
                                    </>
                                ) : (
                                    <>
                                        <label>Provider: </label>
                                        <span>{props.selectedProvider}</span>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="techship-accounts-wrapper">
                            <label>{props.selectedProvider} Accounts</label>
                        </div>
                        <div className="grid-wrapper">
                            <div className="wms-grid-details">
                                <label className="wms_grid_results">
                                    <span>{props.carrierAccList.length}</span>Results
                                </label>
                                <label className="wms_grid_selected">
                                    <span>{totalAccountListSelection}</span>Selected
                                </label>
                            </div>
                            <WMSGridCheckBoxSelection
                                id={props.selector + "CarrierAccountList"}
                                columnMenu={false}
                                filterable={false}
                                columns={columns}
                                schema={schema}
                                staticGridData={props.carrierAccList}
                                gridEditable={{
                                    confirmation: false,
                                }}
                                onSelectRow={selectAccountListRow}
                                bindHeaderSelect={true}
                                keyId={"carrierId"}
                                combineSelectedRow={true}
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className="footer-btn-holder">
                <WmsButton
                    label={window.translate("Label_Close")}
                    buttonType="orange"
                    wmsSelector={props.selector + "exitDynamicConnection"}
                    onClickFunc={props.closeCarrierConnection}
                    icon="fa-times-circle-o"
                />
                {props.isCarrierConnectionWorking !== "Yes" && (
                    <WmsButton
                        label={window.translate("Label_Previous")}
                        wmsSelector={props.selector + "previous"}
                        onClickFunc={movePreviousStep}
                        icon="fa-caret-left"
                    />
                )}
                {!props.isAuthUrl && (
                    <WmsButton
                        label={
                            props.totalSteps === currentStep
                                ? props.isCarrierAccList
                                    ? window.translate("Label_Save_Connection")
                                    : window.translate("Label_Authorize_With") +
                                      (props.selectedCarrier ? props.selectedCarrier : props.selectedProvider)
                                : window.translate("Label_Next")
                        }
                        wmsSelector={props.selector + "next"}
                        onClickFunc={handleClickNext}
                        icon={props.isCarrierAccList ? "" : "fa-caret-right"}
                        loading={props.carrierConnectionBtnLoader}
                        disabled={isDisabledNextButton()}
                    />
                )}
                {props.isAuthUrl && props.isCarrierConnectionWorking !== "Yes" && (
                    <WmsButton
                        label={
                            props.authFlowCurrentStep > 0
                                ? (props.authFlowCurrentStep === 2 && isHaveAuthorization === true) ||
                                  (props.authFlowCurrentStep === 3 && isHaveAuthorization === false)
                                    ? window.translate("Label_Start_Over")
                                    : window.translate("Label_Next")
                                : "Check " + props.selectedCarrier + " Connection"
                        }
                        wmsSelector={props.selector + "CheckConnectionAuthorized"}
                        onClickFunc={
                            (props.authFlowCurrentStep === 2 && isHaveAuthorization === true) ||
                            (props.authFlowCurrentStep === 3 && isHaveAuthorization === false)
                                ? startOverConnectionAuthorize
                                : checkConnectionAuthorized
                        }
                        icon={
                            props.authFlowCurrentStep > 0
                                ? (props.authFlowCurrentStep === 2 && isHaveAuthorization === true) ||
                                  (props.authFlowCurrentStep === 3 && isHaveAuthorization === false)
                                    ? "fa-solid fa-backward"
                                    : "fa-caret-right"
                                : "fa fa-check"
                        }
                        loading={props.carrierConnectionBtnLoader}
                        disabled={isHaveAuthorization == null || showExpiredLinkMsg}
                    />
                )}
            </div>
        </div>
    );
};

DynamicCarrierFormComponent.propTypes = {};

export default React.memo(DynamicCarrierFormComponent);
